var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"basicCont",staticClass:"basic-container"},[_c('div',{staticClass:"el-card",style:({'height': _vm.containerHeight, 'width': _vm.containerWidth})},[_c('el-scrollbar',{staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"padding":"10px"}},[_vm._t("default")],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }